export default __webpack_public_path__ + "slices/main/assets/public/media/home/homepage-community-mobile@2x.dd0049d944696fa5375ab740ff15a94a.jpg";